import { css } from "../helpers/webComponents";
import { Page } from "../enums/Page";
import { GameEventService } from "../services/GameEventService";
import { LoginService } from "../services/LoginService";

const styles: string = css`
    .bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
}

body {
    background-size: cover;
    background-position: center;
    filter: brightness(0.3); /* Nog donkerder contrast */
    color: #fff;
    font-family: 'Press Start 2P', cursive;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    margin: 0;
}

.container {
    background-color: rgba(30, 30, 30, 0.9); /* Donkerder transparant */
    border: 4px solid #555;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.8);
    text-align: center;
    width: 400px;
    height: auto;
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
}


h1 {
    font-size: 24px;
    margin-bottom: 20px;
}

label {
    font-size: 16px;
    margin-bottom: 8px;
    display: block;
}

input[type="text"], input[type="password"] {
    width: calc(100% - 20px); /* Zorgt voor even ruimte links en rechts */
    padding: 12px;
    margin: 8px 0;
    border: 2px solid #555;
    border-radius: 8px;
    background-color: #333;
    color: #fff;
    font-family: 'Press Start 2P', cursive;
    font-size: 14px;
    box-sizing: border-box; /* Houdt padding en border in de breedteberekening */
}


input[type="text"]:focus, input[type="password"]:focus {
    outline: none;
    border-color: #777;
}

button {
    width: 100%;
    padding: 12px;
    background-color: #555;
    color: #fff;
    border: 2px solid #777;
    border-radius: 8px;
    cursor: pointer;
    font-family: 'Press Start 2P', cursive;
    font-size: 16px;
}

button:hover {
    background-color: #777;
}
`;

export class LoginComponent extends HTMLElement {
    private readonly _loginService = new LoginService();
    private readonly _gameEventService = new GameEventService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();

        const button: HTMLButtonElement = this.shadowRoot?.querySelector("#submit") as HTMLButtonElement;
        button.addEventListener("click", async e => {
            e.preventDefault();
            await this.handleLogin();
        });
    }

    private async handleLogin(): Promise<void> {
        const username: string = (this.shadowRoot?.querySelector("#username") as HTMLInputElement).value;
        const password: string = (this.shadowRoot?.querySelector("#password") as HTMLInputElement).value;

        const result: {
            success: boolean;
            sessionId?: string;
        } = await this._loginService.login(username, password);

        console.log("[LoginComponent] Login result:", result);

        if (result.success && result.sessionId) {
            // ✅ Session opslaan
            localStorage.setItem("playerSessionId", result.sessionId);
            localStorage.setItem("user", JSON.stringify({ username }));

            console.log("[LoginComponent] Session opgeslagen:", result.sessionId);

            // 🔄 Forceren dat Canvas opnieuw rendert met sessie actief
            window.dispatchEvent(new CustomEvent("sessionUpdated"));

            // ✅ Ga naar Canvas-pagina
            this._gameEventService.switchPage(Page.Canvas);
        }
        else {
            const msg: HTMLDivElement = this.shadowRoot?.querySelector("#message") as HTMLDivElement;
            msg.textContent = "Login mislukt. Controleer je gegevens.";
            msg.style.color = "red";
        }
    }

    private render(): void {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
            <style>
                ${styles}
            </style>
            <img src="/assets/img/rooms/HomePage.png" class="bg">
            <div class="container">
                <h1>Inloggen</h1>
                <div id="message"></div>
                <label for="username">Gebruikersnaam</label>
                <input type="text" id="username" placeholder="Voer je gebruikersnaam in">
                <label for="password">Wachtwoord</label>
                <input type="password" id="password" placeholder="Voer je wachtwoord in">
                <button id="submit">Login</button>
            </div>
        `;
    }
}
